import {Component, OnInit, ViewChild} from '@angular/core';
import {DateRangeType} from '../../../shared/domain/date-range-type.enum';
import {KitchenDashboardService} from '../kitchen-dashboard.service';
import {ReportResponse} from '../../shared/domain/report/report-response.model';
import {ActivatedRoute, Router} from '@angular/router';
import {MomentDateUtils} from '../../../shared/utils/moment-date-utils';
import {KnDashboardTableComponent} from './kn-dashboard-table.component';
import {DateRangeHolder} from '../../../shared/domain/date-range-holder.model';
import {WidgetDailyMetricsChartComponent} from '../../shared/components/widgets/widget-daily-metrics-chart.component';
import {KnDashboardMetricBoxesComponent} from './kn-dashboard-metric-boxes.component';
import {KitchenDashboardMainWidgetsComponent} from '../main/kn-dashboard-main-widgets.component';

@Component({
  selector: 'cm-kitchen-dashboard',
  templateUrl: './kitchen-dashboard.component.html',
  styleUrls: ['./kitchen-dashboard.component.scss']
})
export class KitchenDashboardComponent implements OnInit {
  @ViewChild(KitchenDashboardMainWidgetsComponent, { static: true }) widgetsComponent: KitchenDashboardMainWidgetsComponent;

  allowedDateRangeTypes = [
    DateRangeType.TODAY,
    DateRangeType.THIS_MONTH,
    DateRangeType.YESTERDAY,
    DateRangeType.LAST_30_DAYS,
    DateRangeType.THIS_WEEK,
    DateRangeType.LAST_MONTH,
    DateRangeType.LAST_7_DAYS,
    DateRangeType.LAST_3_MONTHS,
  ];
  maxDate = MomentDateUtils.today();
  dateRange = new DateRangeHolder(MomentDateUtils.today(), MomentDateUtils.today(), DateRangeType.TODAY);
  data: ReportResponse;
  loading = true;

  constructor(private dashboardService: KitchenDashboardService,
              private route: ActivatedRoute,
              private router: Router) {
    this.route
      .queryParams
      .subscribe(params => {
        this.dateRange.dateFrom = params['dateFrom'] ? params['dateFrom'] : MomentDateUtils.today();
        this.dateRange.dateTo = params['dateTo'] ? params['dateTo'] : MomentDateUtils.today();
      });
  }

  ngOnInit() {
    this.refreshData();
  }

  onDateRangeChanged(range: DateRangeHolder) {
    this.dateRange = range;
    this.refreshData();
    const chartRange = new DateRangeHolder(range.dateFrom, range.dateTo, range.dateRangeType);

    if (range.dateTo === range.dateFrom) {
      const last7days = new Date(new Date(Date.parse(range.dateTo)).getTime() - (7 * 24 * 60 * 60 * 1000));
      chartRange.dateFrom = last7days.toISOString().split('T')[0];
    }

    this.widgetsComponent.daily.onDailyDateRangeChanged(chartRange);
  }

  refreshData() {
    this.router.navigate(['/dashboard'], {
      queryParams: {
        dateFrom: this.dateRange.dateFrom,
        dateTo: this.dateRange.dateTo,
      },
    });
    this.loading = true;
    this.dashboardService.getDashData(this.dateRange.dateFrom, this.dateRange.dateTo).subscribe(next => {
      this.loading = false;
      this.data = <ReportResponse> next;
    }, () => {
      this.loading = false;
    });
  }

}
